module.exports = __webpack_public_path__ + "assets/img/Android.109c4224.svg";